import { createContext, useContext } from 'react';

const NonceContext = createContext<string | undefined>(undefined);

export const useServerOnlyNonce = () => {
  const nonce = useContext(NonceContext);

  // The default value (undefined) will be used on the client render
  return nonce;
};

// Do not use this provider on the client render - it is only to be used in the entry.server.tsx file
// see: https://github.com/remix-run/remix/issues/5162#issuecomment-1400748264
export const NonceProvider = NonceContext.Provider;
